import { useSWRConfig } from "swr";

import {
  CreateTemplateGroupDTO,
  useCreateTemplateGroup,
} from "src/domain/administrative/resource-management/features/templates/api/createTemplateGroup";
import { useDeleteTemplateGroup } from "src/domain/administrative/resource-management/features/templates/api/deleteTemplateGroup";
import { endpoint } from "src/lib/bridgeClient";

export const useUpdateTemplateGroup = () => {
  const createTemplateGroup = useCreateTemplateGroup();
  const deleteTemplateGroup = useDeleteTemplateGroup();
  const { mutate } = useSWRConfig();

  return async (createGroups: CreateTemplateGroupDTO[], deleteGroups: WorkflowTemplateGroup[]) => {
    try {
      const createResults = await createTemplateGroup(createGroups);
      const deleteResults = await deleteTemplateGroup(deleteGroups);
      mutate(endpoint.myOrgWorkflowTemplateGroups);
      return createResults.success && deleteResults.success;
    } catch (error) {
      return error.response;
    }
  };
};
